import React, { memo, useCallback, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useGlobalSearchParams, useLocalSearchParams } from "expo-router";

import Products from "../products";
import { categoryArr } from "utils/Constants";
import { debounce } from "utils/common";
import { setSelectedFiltersWithoutUpdatingUrlParams } from "appRedux/reducers/filterSlice";
import { decodeUrlToFilters } from "utils/filterUtils";

const ShopCategory = ({ category = "" }) => {
  const local = useGlobalSearchParams();

  const selectedFilters = useSelector(
    (state) => state.FilterReducer.selectedFilters,
    shallowEqual
  );
  const allFilters = useSelector((state) => state.FilterReducer.filters || []);

  const dispatch = useDispatch();

  useEffect(() => {
    let active = true;
    if (!allFilters?.filters?.length) return;

    const debouncedEffect = debounce(() => {
      const filterObj = decodeUrlToFilters(local?.filters, allFilters);
      if (
        !local?.filters ||
        !filterObj ||
        (filterObj?.parent?.length == 0 &&
          Object.keys(filterObj?.selected || {}).length == 0)
      ) {
        if (category) {
          if (
            (!selectedFilters?.["1"] ||
              (selectedFilters?.["1"] &&
                Array.isArray(selectedFilters?.["1"]) &&
                selectedFilters?.["1"]?.length == 0) ||
              !selectedFilters?.["1"]?.find((o) => o?.isSubCategory))
          ) {
            if (active) {
              dispatch(
                setSelectedFiltersWithoutUpdatingUrlParams({
                  parent: [categoryArr?.[category]],
                })
              );
            }
          }
        } else {
          dispatch(setSelectedFiltersWithoutUpdatingUrlParams(filterObj || {}));
        }
      } else {
        dispatch(setSelectedFiltersWithoutUpdatingUrlParams(filterObj || {}));
      }
    }, 300);

    debouncedEffect();

    return () => {
      active = false;
    };
  }, [
    JSON.stringify(selectedFilters),
    local?.filters,
    category,
    allFilters?.filters?.length,
  ]);

  return <Products isCategory={true} />;
};

export default ShopCategory;
